import { Component, Input } from "@angular/core";
import { FinanceApiService } from "../../../../services/finance-a-p-iervice.service";
import { LoadingService } from "../../../../services/loading.service";
import { SlabConfig, TariffCalculatedResponse, TariffRuleSet } from "../../../../models/tariff-rule-set";
import { CommonUtils } from "../../../../utils/common-utils";
import { APIResponse } from "../../../../models/standard-response.interface";
import { FormsModule } from "@angular/forms";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import { TariffService } from "../../../../services/tariff.service";
import { TooltipDirective } from "../../../../directives/tooltip.directive";
import { DateUtils } from "../../../../utils/date-utils";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-tariff-overview',
  standalone: true,
  imports: [
    FormsModule,
    NgForOf,
    NgIf,
    NgClass,
    TooltipDirective,
    SvgIconComponent,
    RouterLink
  ],
  templateUrl: './tariff-overview.component.html',
  styleUrl: './tariff-overview.component.scss'
})
export class TariffOverviewComponent {
  ruleSets: TariffRuleSet[] = [];
  slabConfig!: SlabConfig;
  tariffInfo!: any;
  highlightHeaders: { colIndex: number; rowIndex: number } = { colIndex: -1, rowIndex: -1 };

  @Input() tariffCalculatedResponse!: TariffCalculatedResponse;
  @Input() chargeName?: string = "";

  constructor(private financeApiService: FinanceApiService,
              private loadingService: LoadingService,
              protected tariffService: TariffService,) {
  }

  ngOnInit() {
    this.initializeComponent();
  }

  private initializeComponent() {
    if (!CommonUtils.isNotNil(this.tariffCalculatedResponse)) {
      console.error("Tariff ID is required for tariff overview.");
      return;
    }

    this.loadingService.show("inline");
    this.financeApiService.getTariffDetails(this.tariffCalculatedResponse.tariffId).subscribe({
      next: (response: APIResponse) => {
        this.ruleSets = response.data?.rulesets;
        this.slabConfig = response.data?.slabConfig;
        this.tariffInfo = response.data;
        console.log(this.ruleSets, this.slabConfig);
        this.loadingService.hide();
      },
      error: (error: any) => {
        // Handle error response
        console.error("Error fetching tariff details:", error);
        this.loadingService.hide();
      }
    });
  }

  highLightRowAndCol(colIndex: number, rowIndex: number) {
    this.highlightHeaders = { colIndex, rowIndex };
  }

  protected readonly CommonUtils = CommonUtils;

  isRuleSetApplied(ruleSetIndex: number, rowIndex?: number, colIndex?: number): boolean {
    const responses = this.tariffCalculatedResponse.ruleSetCalculationResponses ?? [];

    if (CommonUtils.isNotNil(rowIndex) && CommonUtils.isNotNil(colIndex)) {
      return responses.some(res => res.ruleSetIdx === ruleSetIndex && res.rowIdx === rowIndex && res.colIdx === colIndex);
    }

    if (CommonUtils.isNotNil(colIndex)) {
      return responses.some(res => res.ruleSetIdx === ruleSetIndex && res.colIdx === colIndex);
    }

    if (CommonUtils.isNotNil(rowIndex)) {
      return responses.some(res => res.ruleSetIdx === ruleSetIndex && res.rowIdx === rowIndex);
    }

    return false;
  }

  protected readonly DateUtils = DateUtils;
}
